import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=832971cc&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/musili/musilidev/webroot/work-bmm/01_DEX/dex/front-end/web-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('832971cc')) {
      api.createRecord('832971cc', component.options)
    } else {
      api.reload('832971cc', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=832971cc&", function () {
      api.rerender('832971cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/bmm/views/Dashboard/Dashboard.vue"
export default component.exports